var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column-fluid AuthForms login login-1 mt-14",class:{
    'login-signin-on': this.state === 'signin',
    'login-signup-on': this.state === 'signup',
    'login-forgot-on': this.state === 'forgot',
    'login-reset-on': this.state === 'reset',
  },attrs:{"id":"kt_login"}},[_c('auth-signin-form',{attrs:{"show-header":_vm.showHeader},on:{"auth-show-form":_vm.showForm,"logged-in":_vm.loggedIn}}),_c('auth-signup-form',{on:{"auth-action-cancel":function($event){return _vm.showForm('signin')}}}),_c('auth-forgot-form',{on:{"auth-action-cancel":function($event){return _vm.showForm('signin')}}}),_c('auth-reset-form',{attrs:{"temp-password":_vm.oldPassword},on:{"password-reseted":_vm.goToDashboard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }